// PP9 - registra uso real do sistema (telas abertas e minutos ativos)
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const IDLE_MS = 3 * 60 * 1000;

export default function ActivityTracker() {
  const location = useLocation();
  const lastInput = useRef(Date.now());

  useEffect(() => {
    api.post("/activity/ping", { path: location.pathname, kind: "nav" }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const mark = () => { lastInput.current = Date.now(); };
    const evs = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const timer = setInterval(() => {
      const ativo = document.visibilityState === "visible" && Date.now() - lastInput.current < IDLE_MS;
      if (ativo) api.post("/activity/ping", { path: window.location.pathname, kind: "beat" }).catch(() => {});
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
      evs.forEach((e) => window.removeEventListener(e, mark));
    };
  }, []);

  return null;
}
